module.exports = "/_next/static/images/landing3-desktop-dd16c3cec1cdc5ee30cfab8611d328f9.png";